<template>
	<div class="product-label-wrapper">
		<slot></slot>
		<div
			class="label-short label-text"
			:class="[{'ribbon' : labelStyle && labelStyle.type === 'ribbon',
								'bow': labelStyle && labelStyle.type === 'bow',
								'bow-left': labelStyle && labelStyle.position.horizontally === 'left',
								'bow-right': labelStyle && labelStyle.position.horizontally === 'right'},
								getUniqueId(product.id)]"
			v-if="productHasCustomLabel(product) && labelStyle"
			v-html="sanitizedContent"
		>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import {findLabelOverride, productHasCustomLabel} from "../../helper/ProductHelper";
import appConfig from "../../appconfig";

export default {
	name: "Label",
	props: ["product", "parentComponent"],
	data() {
		return {
			labelStyle: null
		};
	},
	computed: {
		...mapGetters(["tenantSettings", "globalSelectedShop"]),
		channel() {
			return appConfig.channelAlias();
		},
		sanitizedContent() {
			const labelOverride = findLabelOverride(this.product);
			if(labelOverride) {
				return this.$translate(labelOverride.valuesToOverride.text,
					`product.${this.product.id}.labelOverrideText.${this.globalSelectedShop.id}`)
					.replace(/<[^br][^>]+>/ig, "");
			}
			return this.product.options.label.type === "RCM"
				? this.$t("shopComponents.gt3.recommendationEngine.badge.recommended")
				: this.$translate(this.product.options.label.text,
			`product.${this.product.id}.label`)
					.replace(/<[^br][^>]+>/ig, "");
		}
	},
	mounted() {
		const labelOverride = findLabelOverride(this.product);
		const labelObject = labelOverride
			? this.tenantSettings.labels.find(b => b.key === labelOverride.valuesToOverride.labelRef)
			: this.tenantSettings.labels.find(b => b.key === this.product.options.label.labelRef);
		this.labelStyle = labelObject.styles.find(style => style.channels.includes(this.channel));
		if(this.labelStyle) {
			this.setStyles();
		}
	},
	updated() {
		if(this.labelStyle) {
			this.setStyles();
		}
	},
	methods: {
		productHasCustomLabel(product) {
			return productHasCustomLabel(product);
		},
		setStyles() {
			const self = this;
			const labelElems = document.getElementsByClassName(`label-${self.product.id}-${self.parentComponent}`);
			if(labelElems && labelElems.length > 0) {
				for(const labelEl of labelElems) {
					if(labelEl) {
						labelEl.style.color = self.labelStyle.textColour;
						labelEl.style.backgroundColor = self.labelStyle.backgroundColour;
						labelEl.style.fontWeight = self.labelStyle.font.weight;
						labelEl.style.fontSize = self.labelStyle.font.size;
						const margins = self.labelStyle.margin.split(" ");
						// margin should be in format Xpx or Xpx Xpx since we use absolute position and margins
						labelEl.style[self.labelStyle.position.vertically] = margins.length === 2 ? margins[0] : self.labelStyle.margin;
						labelEl.style[self.labelStyle.position.horizontally] = margins.length === 2 ? margins[1] : self.labelStyle.margin;
						labelEl.style.padding = self.labelStyle.padding;
						if (self.labelStyle.type === "pill") {
							labelEl.style.border = `${self.labelStyle.border.width} ${self.labelStyle.border.style} ${self.labelStyle.border.color}`;
							labelEl.style.borderRadius = self.labelStyle.border.radius;
						}
						if (self.labelStyle.type === "ribbon") {
							const translateValue = self.labelStyle.position.horizontally === "left" ? -29.3 : 29.3;
							const rotateValue = (self.labelStyle.position.vertically === "top" && self.labelStyle.position.horizontally === "left") ||
							(self.labelStyle.position.vertically === "bottom" && self.labelStyle.position.horizontally === "right") ? -45 : 45;
							labelEl.style.transformOrigin = `${self.labelStyle.position.vertically} ${self.labelStyle.position.horizontally}`;
							labelEl.style.transform = `translate(${translateValue}%) rotate(${rotateValue}deg)`;
							labelEl.style.boxShadow = `0 0 0 999px ${self.labelStyle.backgroundColour}`;
						}
					}
				}
			}
		},
		getUniqueId(productId) {
			return `label-${productId}-${this.parentComponent}`;
		}
	}
};
</script>

<style scoped lang="scss">
.product-label-wrapper {
	z-index: 1;
	overflow: hidden;
	width: 100%;
	height: 100%;
	position: relative;
	top: initial;
	left: initial;
	font-family: "Dispatch-Black";
	letter-spacing: 0px;
}
.label-text {
	width: fit-content;
	font-size: xx-small;
	position: absolute;
	text-align: center;
}
.ribbon {
	clip-path: inset(0 -100%);
}
</style>
